__turbopack_context__.v({
  "blok-big-title": "description-module__CEHpPa__blok-big-title",
  "blok-subtitle": "description-module__CEHpPa__blok-subtitle",
  "blok-title": "description-module__CEHpPa__blok-title",
  "line-clamp": "description-module__CEHpPa__line-clamp",
  "pdpDescription": "description-module__CEHpPa__pdpDescription",
  "readMore": "description-module__CEHpPa__readMore",
});
